import * as React from "react";
import { WrapperLess } from "../../../../components/generic";

interface OwnProps {
}

export const FDStatement: React.SFC<OwnProps> = (props) => {
    return <WrapperLess>
        <p>
            The American Society of Retina Specialists (ASRS) has implemented a process where everyone who
            is in a position to control the content of a CME activity must disclose to us all relevant financial
            relationships with any commercial interest and any conflicts of interest must be resolved prior to the CME activity.
            Information will be reviewed by the appropriate course director or planning committee chair; a determination will
            be made to manage the conflict with safeguards against any potential bias. This is not intended to prevent
            participation unless the conflict of interest is determined to be unresolvable. Refusal to disclose means that
            you relinquish your ability to participate in the CME activity involved.
        </p>

        <p>
            Circumstances create a <strong>conflict of interest</strong> when an individual has an opportunity to affect CME
            content about products or services of a commercial interest with which he/she has a financial relationship.
        </p>

        <p>
            ACCME and ASRS define <strong>commercial interests</strong><sup>1</sup> as entities producing, marketing, re-selling,
            or distributing health care goods or services consumed by, or used on, patients. Financial relationships are those
            relationships in which the individual or his/her spouse or partner benefits by receiving a salary, royalty, intellectual
            property rights, consulting fee, honoraria, ownership interest (excluding diversified mutual funds), or other financial
            benefit; these are usually associated with roles such as employment, independent contractor (including contracted research),
            consulting, speaking and teaching, advisory/review panel or board membership, etc. A relevant financial relationship is
            one that creates a conflict of interest, in any amount, occurring in the 12 months before the individual
            assumes a role controlling CME content.
        </p>

        <p>
            Please list the names of commercial interest(s) with which you or your spouse/partner have, or have had, a relevant
            financial relationship within the past 12 months. Please describe what you or your spouse/partner
            received (ex: salary, honorarium, etc.), and describe your role.
        </p>

        <p className="mute">
            <sup>1</sup>A <em>commercial interest</em> is any entity producing, marketing, re-selling, or distributing health
            care goods or services consumed by, or used on, patients. The ACCME does not consider providers of clinical
            service directly to patients to be commercial interests.
        </p>

        <p className="mute">
            A commercial interest is not eligible for ACCME accreditation. Commercial interests cannot be accredited providers
            and cannot be joint sponsors. Within the context of this definition and limitation, the ACCME considers the following
            types of organizations to be eligible for accreditation and free to control the content of CME: 501-C Non-profit
            organizations (Note, ACCME screens 501c organizations for eligibility.  Those that advocate for commercial interests
            as a 501c organization are not eligible for accreditation in the ACCME system. They cannot serve in the role of joint
            sponsor, but they can be a commercial supporter), Government organizations, Non-health care related companies, Liability
            insurance providers, Health insurance providers, Group medical practices, For-profit hospitals, For profit rehabilitation
            centers, For-profit nursing homes, Blood bank, Diagnostic laboratories.
        </p>
    </WrapperLess>;
};



// WEBPACK FOOTER //
// ./src/containers/user/financialDisclosure/components/FDStatement.tsx